@if (!(vm$ | async)?.consentAccepted) {
  <dff-cookie-consent-overlay>
    @if (imageUrl) {
      <img [src]="imageUrl" />
    }
  </dff-cookie-consent-overlay>
}
